import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Constant } from '../constant';
import {EventBrochureComponent} from './event-brochure.component';
import {
  EventOperationApiService,
  EventOperationSettings,
} from '../event-operation-settings/event-operation-api.service';

@Component({
  selector: 'app-event-operation-hub',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule, EventBrochureComponent],
  templateUrl: './event-operation-hub.component.html',
  styleUrl: './event-operation-hub.component.css',
})
export class EventOperationHubComponent implements OnInit {
  eventId = 0;
  loading = true;
  errorMessage = '';
  settings: EventOperationSettings | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: EventOperationApiService,
    private title: Title,
  ) {
    this.title.setTitle(`イベント運営${Constant.pageTitleCommon}`);
  }

  ngOnInit(): void {
    const value = Number(this.route.snapshot.paramMap.get('id'));
    if (!Number.isSafeInteger(value) || value <= 0) {
      this.loading = false;
      this.errorMessage = 'イベントを確認できませんでした。';
      return;
    }
    this.eventId = value;
    this.load();
  }

  async load(): Promise<void> {
    this.loading = true;
    this.errorMessage = '';
    try {
      this.settings = await this.api.get(this.eventId);
      if (this.settings.featuresVisible === false) this.errorMessage = '出欠・アンケートは現在停止しています。';
    } catch (error: any) {
      this.errorMessage = error?.error?.message || error?.message || 'イベント運営画面を表示できませんでした。';
    } finally {
      this.loading = false;
    }
  }

  back(): void {
    this.router.navigate(['/myevent']);
  }

  get attendanceAvailable(): boolean {
    return !!this.settings && this.settings.featuresVisible !== false && (
      this.settings.hasAttendanceData ||
      (this.settings.attendanceSelected && this.settings.releaseControls.attendance.canWrite)
    );
  }

  get surveyAvailable(): boolean {
    return !!this.settings && this.settings.featuresVisible !== false && (
      this.settings.hasSurveyData ||
      (this.settings.surveySelected && this.settings.releaseControls.survey.canWrite)
    );
  }

  openAttendance(): void {
    if (!this.attendanceAvailable) return;
    if (this.settings?.attendanceKind === 'guest') {
      this.router.navigate(['/myevent-operation', this.eventId, 'guest-attendance']);
      return;
    }
    this.router.navigate(['/myevent-detail', this.eventId, 'attendance'], {
      queryParams: { entry: 'operations' },
    });
  }

  openSurvey(): void { if(this.surveyAvailable)this.router.navigate(['/myevent-operation',this.eventId,'survey']); }

  scheduleLabel(schedule: EventOperationSettings['operationalBrief']['schedules'][number]): string {
    if (!schedule.eventDate) return '';
    const times = [schedule.startTime?.slice(0, 5), schedule.endTime?.slice(0, 5)].filter(Boolean).join('〜');
    return `${schedule.eventDate.replaceAll('-', '/')} ${times}`.trim();
  }
}
